import convertClusterToTimeline from "./convert-cluster-to-timeline";

/**
 * Convert single-type timeline
 * @example `s(0.5)`
 * @param {String} input
 * @param {Array<String>} results
 */
const convertSingleTimeline = (input, results) => {
  const split = input.split(":");

  if (split[1]) {
    /** Has trigger */
    const trigger = split[0];
    const properties = split[1];
    const cluster = properties.endsWith("]");
    const attributes = convertClusterToTimeline(trigger, properties, cluster);

    results.push(...attributes);
  } else {
    /** Initial property */
    results.push(`[0s_[${input}]]`);
  }
};

export default convertSingleTimeline;
